import { useMutation } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

import { Rubric } from './useGetCompetencyDetails';

interface UpdateCompetencyRubricsResponse {
  errors?: string;
}

interface UpdateCompetencyRubricsVariables {
  interviewUid: string;
  competencyUid: string;
  rubrics: Rubric[];
}

const useUpdateCompetencyRubrics = () => {
  const {
    mutateAsync: updateCompetencyRubrics,
    data,
    isLoading,
    error,
  } = useMutation<
    UpdateCompetencyRubricsResponse,
    Error,
    UpdateCompetencyRubricsVariables
  >(
    ['updateCompetencyRubrics'],
    async ({ interviewUid, competencyUid, rubrics }) => {
      const body = {
        interview: interviewUid,
        uid: competencyUid,
        rubrics,
      };
      const assessment =
        await fetchWithCsrfToken<UpdateCompetencyRubricsResponse>(
          `${PrependUrl.ASYNC}/competency/update_rubrics`,
          'POST',
          body
        );

      return assessment;
    }
  );

  return {
    updateCompetencyRubrics,
    data,
    isLoading,
    error,
  };
};

export default useUpdateCompetencyRubrics;
